import PropTypes from "prop-types"
import styles from "./ToggleButton.module.scss"

const ToggleButton = ({ label, isChecked, onChange }) => {
  return (
    <div className={styles.toggleContainer}>
      {label && <span className={styles.toggleLabel}>{label}</span>}
      <label className={styles.toggleSwitch} aria-label="Toggle button">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className={styles.slider} />
      </label>
    </div>
  )
}

ToggleButton.propTypes = {
  label: PropTypes.string,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func
}

export default ToggleButton
